var map = {
	"./connect.png": 9112,
	"./down.png": 72081,
	"./money.png": 12178,
	"./pay.png": 59962,
	"./solutions.png": 51811,
	"./solutions_background_image.png": 45882,
	"./up.png": 40232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91342;